<mat-toolbar color="primary" mat-dialog-title fxLayout fxLayoutAlign="center center">
    <span>{{title | transloco | uppercase}}</span>
</mat-toolbar>

<mat-dialog-content [formGroup]="form" class="flex flex-col gap-1 pt-5" [ngClass]="{'opacity-50 pointer-events-none': isLoading}">
    <mat-form-field class="fuse-mat-bold w-full fuse-mat-dense">
        <mat-label>{{ 'VERIFICATION.ARGUMENTS' | transloco }}</mat-label>
        <textarea matInput required formControlName="arguments" [rows]="3"></textarea>
        <mat-error *ngIf="form.get('arguments')?.hasError('required')">{{ 'COMMON.REQUIRED_FIELD' | transloco }}</mat-error>
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-row items-center justify-center">
    <button mat-raised-button [disabled]="form.invalid || isLoading" (click)="onSubmit()" color="primary" [ngClass]="{'pr-2': isLoading}" *ngIf="!isWarnBotton">
        <div class="flex items-center">
            <div>{{confirmAction | transloco}}</div>
            <fa-icon *ngIf="isLoading"
                     class="relative flex justify-center items-center animate-spin rounded-full w-9 h-9 text-xl text-white"
                     [icon]="faSpinner">
            </fa-icon>
        </div>
    </button>
    <button mat-raised-button [disabled]="form.invalid || isLoading" (click)="onSubmit()" color="warn" *ngIf="isWarnBotton" [ngClass]="{'pr-2': isLoading}">
        <div class="flex items-center">
            <div>{{confirmAction | transloco}}</div>
            <fa-icon *ngIf="isLoading"
                     class="relative flex justify-center items-center animate-spin  bg-yellow-#FF6D03 rounded-full w-9 h-9 text-xl text-white"
                     [icon]="faSpinner">
            </fa-icon>
        </div>
    </button>
    <button [disabled]="isLoading" mat-raised-button mat-dialog-close="close">{{cancelAction | transloco}}</button>
</mat-dialog-actions>
